"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxButton = void 0;
var react_1 = __importDefault(require("react"));
var icons_1 = require("../../../../../../../icons");
var themes_1 = require("../../../../../../themes");
var styled_1 = require("./styled");
var _EXPORTS_1 = require("../../../../../../../utils/_EXPORTS");
var mixins_1 = require("../../../../../../../themes/mixins");
var Check = icons_1.icons.Check, Minus = icons_1.icons.Minus;
var white = themes_1.colors.white, grey40 = themes_1.colors.grey40;
/**
 * value and onChange are being passed as props so
 * that it can be generated dynamically via our
 * block generators.
 */
var CheckboxButton = function (_a) {
    var _b;
    var id = _a.id, className = _a.className, _isSelected = _a.isSelected, isMixture = _a.isMixture, //basically if isSelected/value && isMixture is true, then we get that '-' thing in the checkbox (useful on table headers where some (not all) rows are selected below)
    value = _a.value, //can be used interchangibly with isSelected
    onChange = _a.onChange, disabled = _a.disabled, invert = _a.invert, S = _a.S;
    var isSelected = (_b = _isSelected !== null && _isSelected !== void 0 ? _isSelected : value) !== null && _b !== void 0 ? _b : false;
    var CheckIcon = (isSelected && isMixture)
        ? Minus
        : isSelected
            ? Check
            : undefined;
    var screenWidth = (0, _EXPORTS_1.useScreenWidth)();
    return (react_1.default.createElement(styled_1.StyledCheckbox, { style: { overflow: 'hidden' }, onClick: function (e) {
            // e.preventDefault();
            // e.stopPropagation(); //this disables the checkbox in checkboxlist which we dont want. so commented. tho we might need this later in table usecase in which case we will have to make stopPropagration a prop
            onChange && onChange(id, !isSelected);
        }, className: className, isSelected: isSelected, disabled: disabled, invert: invert, S: S }, isSelected && (react_1.default.createElement("div", { style: { filter: "drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.25))", display: 'flex' } },
        react_1.default.createElement(CheckIcon, { weight: "bold", color: disabled ? grey40 : white, size: screenWidth >= (0, mixins_1.getBreakPoint)('md') ? 14 : 16, style: {
                flexShrink: 0,
            } })))));
};
exports.CheckboxButton = CheckboxButton;
